import React, { Component } from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';

class CheckboxList extends Component {

    constructor(props) {
      super(props);
      this.state = {
        checkboxes: props.data.map(x => false)
      }
    }

    state = {
      checkboxes: []
    }

    handleToggle(value, index) {
      this.state.checkboxes[index] = !this.state.checkboxes[index];
      var tmp = [].concat(this.state.checkboxes);
      this.setState({ checkboxes: tmp })
    }

    getListOfSelected() {
      var output = [];
      this.state.checkboxes.forEach((cbx, index) => {
        if(cbx) {
          output.push(this.props.data[index]);
        }
      })
      return output;
    }

    render() {
        return (
            <List dense>
              {this.props.data.map((value, index) => (
                <ListItem key={index} dense button onClick={() => this.handleToggle(value, index)} >
                    <Checkbox onChange={(e) => this.handleToggle(value, index)} onClick={(e) => e.stopPropagation()} checked={this.state.checkboxes[index]} disableRipple />
                    {
                        value.avatar ?
                        <ListItemAvatar>
                            <Avatar src={value.avatar} />
                        </ListItemAvatar>
                        : null
                    }
                  <ListItemText primary={value.primary} secondary={value.secondary || ''} />
                  {/* 
                  <ListItemSecondaryAction>
                    
                  </ListItemSecondaryAction> 
                  */}
                </ListItem>
              ))}
            </List>
          );
    }
  }
  
  export default CheckboxList;